import { useAuth0 } from '@auth0/auth0-react';
import { Layout, Menu, Breadcrumb, Dropdown } from 'antd';
import Logo from 'assets/images/logo.svg';
import React from 'react';
import {
  isHamMenuVisible,
  toggleHamMenu,
  toggleData,
  dataSource,
} from 'models/Slices/GlobalSlice';
import { useAppDispatch, useAppSelector } from 'app/hooks';
import { resetStore } from 'utils/commonFilter/resetStore';
import { useLocation } from 'react-router-dom';
const { Header } = Layout;

export const AppHeader: React.FC<{
  headerTitle?: string;
  breadcrumbTitle?: string;
  breadcrumbSubtitle?: string;
}> = (props) => {
  const { logout, user } = useAuth0();
  const location = useLocation();
  const hamMenuActive = useAppSelector(isHamMenuVisible);
  const dispatch = useAppDispatch();
  const DataSource = useAppSelector(dataSource);
  const selectedKeys = DataSource ? [DataSource.toString()] : [];

  const handleNavigate = (selectedDataSource: 'skyBox' | 'stubHub') => {
    const currentPath = location.pathname;
    dispatch(toggleData(selectedDataSource));
    resetStore();

    const pathSegments = currentPath.split('/');

    if (pathSegments[1] === 'skybox' 
        || pathSegments[1] === 'stubhub'
      ) {
      pathSegments[1] = selectedDataSource.toLowerCase();
      if(pathSegments.length > 4) pathSegments.pop()
      const newPath = pathSegments.join('/');

      window.location.href = newPath;
    }
  };

  const userDropdown = (
    <Menu
      className="userAccountDd"
      selectedKeys={selectedKeys}
      selectable={true}
    >
      {/* <Menu.Item>{user?.name}</Menu.Item> */}
      {/* <Menu.Item key="skyBox" onClick={() => handleNavigate('skyBox')}>
        SkyBox
      </Menu.Item>
      <Menu.Item key="stubHub" onClick={() => handleNavigate('stubHub')}>
        StubHub
      </Menu.Item> */}
      <Menu.Item
        key={'logout'}
        onClick={() =>
          logout({
            returnTo: window.location.origin,
          })
        }
      >
        Logout
      </Menu.Item>
    </Menu>
  );

  let appHeaderTitle = props.headerTitle ? (
    <Breadcrumb className="breadcrumb">
      <Breadcrumb.Item href="">
        <span>{props.breadcrumbTitle}</span>
      </Breadcrumb.Item>
      <Breadcrumb.Item>{props.breadcrumbSubtitle}</Breadcrumb.Item>
    </Breadcrumb>
  ) : (
    <h3>{props.headerTitle}</h3>
  );

  return (
    <React.Fragment>
      <Header className="header">
        <div className="headerLeft">
          <a href="#/" className="logo" onClick={(e) => e.preventDefault()}>
            <img src={Logo} alt="" title="Ticket Bash" />
          </a>

          {appHeaderTitle}
          {DataSource.toUpperCase()}
        </div>
        <ul className="headerRight">
          {/* <li>
          <div>
            <i className="da icon-bell" />
          </div>
        </li>
        <li>
          <div>
            <i className="da icon-question" />
          </div>
        </li>
        <li>
          <div>
            <i className="da icon-user" />
          </div>
        </li> */}
          <li className="username">
            <Dropdown overlay={userDropdown} placement={'bottomRight'}>
              <a
                href="#/"
                className="dropdown-btn"
                onClick={(e) => e.preventDefault()}
              >
                {user?.nickname} <i className="da icon-arrow-down" />
              </a>
            </Dropdown>
          </li>
        </ul>
      </Header>
      <div className="dashboardLogoArea">
        <span
          className={`hamburgerMenu ${hamMenuActive ? 'active' : ''}`}
          onClick={() => {
            dispatch(toggleHamMenu(hamMenuActive));
          }}
        >
          <i className="da icon-hamburger" />
        </span>
        <a href="#/" className="logo" onClick={(e) => e.preventDefault()}>
          <img src={Logo} alt="" title="Ticket Bash" />
        </a>
      </div>
    </React.Fragment>
  );
};

export default AppHeader;
